import React from 'react';
import { LazyLoadMedia } from 'src/ui/common/organisms/lazy-load-media';
import {
    StyledCreatorName,
    StyledDescription, StyledImgPreviewWrapper, StyledImgWrapper, StyledInfo, StyledName, StyledWrapper
} from './collection-card-big-preloader.styles';

export const CollectionCardBigPreloader = () => (
    <StyledWrapper>
        <StyledImgWrapper>
            <LazyLoadMedia ratio={65} />
        </StyledImgWrapper>
        <StyledInfo>
            <StyledImgPreviewWrapper>
                <LazyLoadMedia width={76} height={76} />
            </StyledImgPreviewWrapper>
            <StyledCreatorName />
            <StyledName justifyContent='center' />
            <StyledDescription width='254px' />
            <StyledDescription width='200px' />
        </StyledInfo>
    </StyledWrapper>
);
